// Contenu éditorial de référence (pages SEO/GEO « cornerstone »).
// Chaque guide est auto-porteur : titre, méta, sections H2/H3, FAQ et maillage interne.
export const GUIDES = [
  {
    slug: "pourquoi-un-mini-site-professionnel",
    category: "Professionnels",
    title: "Pourquoi créer un mini-site professionnel en Eure-et-Loir ?",
    metaTitle: "Pourquoi un mini-site professionnel ? Avantages & SEO local (28) | PROXIreduc-28",
    metaDescription:
      "Mini-site vs réseaux sociaux : pourquoi un vrai mini-site professionnel référencé Google est indispensable pour un artisan ou commerçant en Eure-et-Loir. Avantages, SEO local et exemples.",
    excerpt:
      "Un mini-site professionnel est votre adresse officielle sur le web : il vous rend visible sur Google, vous appartient et travaille pour vous 24h/24.",
    h1: "Pourquoi créer un mini-site professionnel en Eure-et-Loir ?",
    intro:
      "Beaucoup d'artisans et de commerçants comptent uniquement sur une page Facebook ou le bouche-à-oreille. C'est insuffisant pour être trouvé par de nouveaux clients. Un mini-site professionnel référencé localement devient votre vitrine officielle, indexée par Google et consultable à toute heure, sans dépendre d'un algorithme de réseau social.",
    sections: [
      {
        h2: "Qu'est-ce qu'un mini-site professionnel ?",
        paragraphs: [
          "Un mini-site est un site web compact et structuré autour de votre activité : page d'accueil, produits ou services, coordonnées, horaires, photos et réseaux sociaux. Contrairement à une simple fiche, chaque page possède sa propre adresse (URL), ce qui multiplie vos chances d'apparaître sur les moteurs de recherche.",
          "Sur PROXIreduc-28, le mini-site est optimisé pour le référencement local : il cible naturellement les recherches du type « plombier à Chartres » ou « fleuriste à Dreux ».",
        ],
      },
      {
        h2: "Les avantages concrets d'un mini-site local",
        list: [
          "Visibilité sur Google : vos pages sont indexées pour les recherches de proximité.",
          "Crédibilité : une vraie vitrine rassure davantage qu'une simple page de réseau social.",
          "Autonomie : votre contenu vous appartient et reste accessible même si un réseau change ses règles.",
          "Conversion : horaires, téléphone, itinéraire et demande de devis au même endroit.",
          "Maillage : vos pages sont reliées aux bons plans, guides et au réseau de professionnels du territoire.",
        ],
      },
      {
        h2: "Mini-site ou page Facebook : que choisir ?",
        paragraphs: [
          "Les deux sont complémentaires. Le réseau social entretient le lien avec votre communauté, tandis que le mini-site capte les clients qui cherchent activement un professionnel sur Google. Sans mini-site, vous êtes invisible pour cette audience à forte intention d'achat.",
        ],
      },
      {
        h2: "Comment créer son mini-site sur PROXIreduc-28 ?",
        paragraphs: [
          "Créez votre compte professionnel, activez l'offre Fondateurs (12 mois gratuits, sans carte bancaire) puis renseignez vos informations. Votre mini-site est en ligne et référencé en quelques minutes.",
        ],
      },
    ],
    faq: [
      { q: "Un mini-site est-il vraiment référencé sur Google ?", a: "Oui. Chaque page de votre mini-site PROXIreduc-28 est optimisée SEO et indexable, ce qui permet d'apparaître sur les recherches locales de l'Eure-et-Loir." },
      { q: "Faut-il des compétences techniques ?", a: "Non. Le mini-site se configure via un formulaire simple, sans code ni hébergement à gérer." },
      { q: "Combien coûte un mini-site professionnel ?", a: "Il est inclus gratuitement pendant 12 mois avec l'offre Fondateurs, sans engagement." },
    ],
    related: [
      { label: "Découvrir l'espace professionnel", to: "/pour-les-professionnels" },
      { label: "Devenir partenaire", to: "/devenir-partenaire" },
      { label: "La carte de visite digitale", to: "/carte-de-visite-digitale" },
    ],
    cta: { label: "Activer mon mini-site — 0 €", to: "/devenir-partenaire/inscription/fondateur" },
  },
  {
    slug: "carte-de-visite-digitale-avantages",
    category: "Professionnels",
    title: "La carte de visite digitale : avantages pour les pros",
    metaTitle: "Carte de visite digitale : avantages, QR code & vCard | PROXIreduc-28",
    metaDescription:
      "Pourquoi adopter une carte de visite digitale ? Partage par QR code et vCard, mise à jour en temps réel, référencement local en Eure-et-Loir. Le guide complet PROXIreduc-28.",
    excerpt:
      "Partageable par QR code et vCard, toujours à jour et écologique : la carte de visite digitale remplace avantageusement le carton papier.",
    h1: "La carte de visite digitale : tous les avantages",
    intro:
      "La carte de visite papier se perd, se périme et finit souvent à la poubelle. La carte de visite digitale, elle, se partage en un geste, se met à jour en temps réel et renvoie directement vers vos coordonnées, votre mini-site et vos réseaux.",
    sections: [
      {
        h2: "Comment fonctionne une carte de visite digitale ?",
        paragraphs: [
          "C'est une page professionnelle en ligne que vous partagez via un QR code, un lien, un fichier vCard (à enregistrer dans les contacts) ou un PDF. Aucune application à installer pour la personne qui la reçoit.",
        ],
      },
      {
        h2: "Les avantages pour un professionnel",
        list: [
          "Partage instantané en rendez-vous, en boutique ou sur vos supports.",
          "Mise à jour en temps réel : vos coordonnées sont toujours exactes.",
          "Enregistrement direct dans le téléphone de vos contacts (vCard).",
          "Visibilité locale : la carte publique est indexable sur PROXIreduc-28.",
          "Écologique et économique : plus de réimpression de cartons.",
        ],
      },
      {
        h2: "Carte digitale et mini-site : le duo gagnant",
        paragraphs: [
          "La carte de visite digitale est le point d'entrée rapide vers votre univers : d'un scan, le prospect accède à votre mini-site référencé, vos offres et vos moyens de contact.",
        ],
      },
    ],
    faq: [
      { q: "La carte de visite digitale est-elle gratuite ?", a: "Oui, elle est incluse gratuitement avec l'offre Fondateurs de PROXIreduc-28 pour les professionnels de l'Eure-et-Loir." },
      { q: "Comment la partager sans application ?", a: "Via un QR code à présenter, un lien direct, une vCard ou un PDF : le destinataire n'a rien à installer." },
      { q: "Puis-je la mettre à jour après l'avoir partagée ?", a: "Oui. Toute modification est immédiatement visible pour quiconque ouvre votre carte." },
    ],
    related: [
      { label: "Créer ma carte de visite digitale", to: "/carte-de-visite-digitale" },
      { label: "Pourquoi un mini-site professionnel", to: "/guides/pourquoi-un-mini-site-professionnel" },
      { label: "Devenir partenaire", to: "/devenir-partenaire" },
    ],
    cta: { label: "Créer ma carte digitale — 0 €", to: "/carte-de-visite-digitale" },
  },
  {
    slug: "etre-visible-sur-google-commerce-local",
    category: "Visibilité locale",
    title: "Comment être visible sur Google quand on est un commerce local",
    metaTitle: "Être visible sur Google : guide SEO local pour commerces (28) | PROXIreduc-28",
    metaDescription:
      "Le guide du référencement local pour les commerces et artisans d'Eure-et-Loir : mots-clés par ville, fiche Google, mini-site, avis clients et maillage. Gagnez en visibilité locale.",
    excerpt:
      "Référencement local, mots-clés par ville, avis clients et mini-site : les leviers concrets pour apparaître sur Google près de chez vos clients.",
    h1: "Comment être visible sur Google quand on est un commerce local",
    intro:
      "Quand un habitant de Chartres ou de Dreux cherche un professionnel, il tape le plus souvent « métier + ville » sur Google. Être présent sur ces recherches est la clé pour capter des clients proches, prêts à acheter. Voici comment procéder concrètement.",
    sections: [
      {
        h2: "Cibler les recherches « métier + ville »",
        paragraphs: [
          "Les recherches locales (« coiffeur Lucé », « garagiste Châteaudun ») ont une forte intention d'achat. Votre présence web doit contenir ces expressions dans vos titres, descriptions et contenus, de façon naturelle.",
        ],
      },
      {
        h2: "Les 5 leviers du référencement local",
        list: [
          "Un mini-site structuré, avec une page par service et par zone desservie.",
          "Une fiche d'établissement (Google Business Profile) complète et à jour.",
          "Des avis clients réguliers et des réponses à ces avis.",
          "Des coordonnées cohérentes partout (nom, adresse, téléphone).",
          "Un maillage local : être cité par des guides et annuaires du territoire.",
        ],
      },
      {
        h2: "Le rôle d'une plateforme locale",
        paragraphs: [
          "Figurer sur une plateforme de proximité comme PROXIreduc-28 renforce votre référencement : votre fiche, vos offres et votre mini-site sont reliés aux pages de bons plans par ville et par catégorie, ce qui multiplie les points d'entrée vers votre activité.",
        ],
      },
    ],
    faq: [
      { q: "Combien de temps pour apparaître sur Google ?", a: "L'indexation prend généralement de quelques jours à quelques semaines. Un contenu local régulier et des avis accélèrent la visibilité." },
      { q: "Faut-il payer Google pour être visible ?", a: "Non pour le référencement naturel (SEO). Un mini-site optimisé et une fiche d'établissement complète suffisent pour commencer." },
      { q: "Les avis clients sont-ils importants ?", a: "Oui, ils influencent fortement le classement local et la confiance des clients." },
    ],
    related: [
      { label: "Pourquoi un mini-site professionnel", to: "/guides/pourquoi-un-mini-site-professionnel" },
      { label: "Le réseau de professionnels locaux", to: "/reseau-pro" },
      { label: "Toutes les villes du 28", to: "/villes" },
    ],
    cta: { label: "Référencer mon commerce — 0 €", to: "/devenir-partenaire/inscription/fondateur" },
  },
  {
    slug: "faire-connaitre-son-association-eure-et-loir",
    category: "Associations",
    title: "Comment faire connaître son association en Eure-et-Loir",
    metaTitle: "Faire connaître son association en Eure-et-Loir (28) — guide gratuit | PROXIreduc-28",
    metaDescription:
      "Donner de la visibilité à son association ou son club en Eure-et-Loir : page publique, communication des événements, recrutement de membres. Guide pratique et gratuit PROXIreduc-28.",
    excerpt:
      "Page publique, communication des événements et recrutement de membres : les étapes pour donner de la visibilité à votre association locale.",
    h1: "Comment faire connaître son association en Eure-et-Loir",
    intro:
      "Les associations et clubs font vivre le territoire, mais peinent souvent à recruter de nouveaux membres et à communiquer. Une présence numérique claire et locale change la donne, sans budget.",
    sections: [
      {
        h2: "Créer une page publique de présentation",
        paragraphs: [
          "Une page dédiée présente votre objet, vos activités, vos créneaux et vos contacts. Elle est indexable et devient le point de référence lorsqu'un habitant recherche votre association.",
        ],
      },
      {
        h2: "Communiquer sur ses événements",
        list: [
          "Annoncez vos temps forts (assemblées, tournois, portes ouvertes).",
          "Publiez vos actualités pour entretenir le lien avec vos membres.",
          "Partagez facilement vers les réseaux et communautés locales.",
        ],
      },
      {
        h2: "Recruter et fidéliser des membres",
        paragraphs: [
          "Un lien d'adhésion clair, une communication régulière et une bonne visibilité locale facilitent l'arrivée de nouveaux adhérents. PROXIreduc-28 met ces outils à disposition gratuitement pour les associations et les clubs du département.",
        ],
      },
    ],
    faq: [
      { q: "La page association est-elle gratuite ?", a: "Oui, la présence des associations et des clubs est entièrement gratuite sur PROXIreduc-28." },
      { q: "Peut-on annoncer ses événements ?", a: "Oui, vous pouvez publier vos événements et actualités, puis les partager vers les réseaux locaux." },
      { q: "Comment recruter de nouveaux membres ?", a: "Grâce à une page publique visible, à la communication de vos activités et à un lien d'adhésion simple à partager." },
    ],
    related: [
      { label: "Espace associations", to: "/pour-les-associations" },
      { label: "Toutes les associations", to: "/associations" },
      { label: "Les clubs du territoire", to: "/clubs" },
    ],
    cta: { label: "Créer la page de mon association", to: "/associations/inscription" },
  },
];

export const getGuide = (slug) => GUIDES.find((g) => g.slug === slug) || null;
